import { useState } from "react";
import { useAppSelector } from "../../../hooks";
import { Card, CardContent, CardHeader, Container, Divider, Stack, Typography, FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { formatTime, getKnockoutRoundType } from "../../../utils";

export default function TableView() {
  const [locationFilter, setLocationFilter] = useState<string>("all");
  const matches = [...useAppSelector((state) => state.matches.groupMatches)]
    .sort((a, b) => a.location.location.localeCompare(b.location.location))
    .sort((a, b) => a.startTime - b.startTime);

  const locations = Array.from(
    new Set(matches.map((match) => match.location.location))
  );

  const filteredMatches =
    locationFilter === "all"
      ? matches
      : matches.filter((match) => match.location.location === locationFilter);

  return (
    <Container maxWidth="xl">
      <Stack spacing={3}>
        <Stack direction="row" justifyContent="space-between" spacing={4}>
          <Typography variant="h4">Tabel</Typography>
        </Stack>
        <Card>
          <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={2} sx={{ p: 2 }}>
            <CardHeader subheader="" title="Tabelvisning af turneringsplan" />
            <FormControl sx={{ minWidth: 200 }}>
              <InputLabel id="location-filter-label">Bane</InputLabel>
              <Select
                labelId="location-filter-label"
                value={locationFilter}
                label="Bane"
                onChange={(e) => setLocationFilter(e.target.value)}
              >
                <MenuItem value="all">Alle baner</MenuItem>
                {locations.map((loc) => (
                  <MenuItem key={loc} value={loc}>
                    {loc}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Stack>
          <Divider />
          <CardContent>
            <Stack spacing={3}>
              <TableContainer component={Paper}>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell align="right">Start</TableCell>
                      <TableCell align="right">Hometeam</TableCell>
                      <TableCell align="right">Awayteam</TableCell>
                      <TableCell align="right">Pulje</TableCell>
                      <TableCell align="right">Gruppe</TableCell>
                      <TableCell align="right">Bane</TableCell>
                      <TableCell align="right">Dommer</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {filteredMatches.map((match, index) => (
                      <TableRow key={match.id}>
                        <TableCell align="right">{formatTime(match.startTime)}</TableCell>
                        <TableCell align="right">{match.homeTeam?.teamName ?? match.homeTeamLabel ?? "-"}</TableCell>
                        <TableCell align="right">{match.awayTeam?.teamName ?? match.awayTeamLabel ?? "-"}</TableCell>
                        <TableCell align="right">{match.pulje.puljeName}</TableCell>
                        <TableCell align="right">{`${match.knockoutMatchId ? `${getKnockoutRoundType(match.knockoutMatchId as any)}` : `${match.group?.name}`}`}</TableCell>
                        <TableCell align="right">{match.location.location}</TableCell>
                        <TableCell align="right">{match.referees.map(referee => referee.referee.name).join(", ")}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Stack>
          </CardContent>
          <Divider />
        </Card>
      </Stack>
    </Container>
  );
}
